<div [formGroup]="sendTextDetailsForm">
  <bit-form-field class="bv-send-field">
    <bit-label>{{ "sendTypeText" | i18n }}</bit-label>
    <input bitInput type="text" formControlName="text" [readonly]="formDisabled()" />
    @if (editing()) {
      <bit-hint>{{ "bvSendTextHint" | i18n }}</bit-hint>
    }
  </bit-form-field>
  @if (showHiddenCheckbox()) {
    <bit-form-control class="bv-send-checkbox">
      <input bitCheckbox type="checkbox" formControlName="hidden" />
      <bit-label>{{ "hideTextByDefault" | i18n }}</bit-label>
    </bit-form-control>
  }
</div>
